export const decodeStringInJson = obj => {
    for(const prop in obj){
        if(obj[prop] != null && typeof obj[prop] === 'object'){
            obj[prop] = decodeStringInJson(obj[prop]);
        } else if(typeof obj[prop] === 'string'){
            obj[prop] = new DOMParser().parseFromString(obj[prop], "text/html").documentElement.textContent;
        }
    }
    return obj;
}